import { render, staticRenderFns } from "./PaymentRaya.vue?vue&type=template&id=36e3fcea"
import script from "./PaymentRaya.vue?vue&type=script&lang=js"
export * from "./PaymentRaya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports